import {z} from 'zod';

export const TransferOrderVariantFormSchema = z.object({
  name: z.string(),
  authorizationProfileId: z.string(),
  docSeriesId: z.string(),
  printoutTemplateId: z.string().nullish(),
});

export type TransferOrderVariantForm = z.infer<typeof TransferOrderVariantFormSchema>;
